module.exports = __webpack_public_path__ + "static/img/17.2cc212b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/17.jpg
// module id = J7pn
// module chunks = 0